import { useEffect, useState } from 'react'

/**
 * Dark mode is a requirement, not an extra (appendix A §A2): most of this
 * audience reads in a dark environment. The stored choice is applied by an
 * inline script in the document head so the first paint is already correct;
 * this control only flips it.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<'light' | 'dark'>('light')

  useEffect(() => {
    const attribute = document.documentElement.getAttribute('data-theme')
    if (attribute === 'dark' || attribute === 'light') {
      setTheme(attribute)
      return
    }
    setTheme(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
  }, [])

  function toggle() {
    const next = theme === 'dark' ? 'light' : 'dark'
    setTheme(next)
    document.documentElement.setAttribute('data-theme', next)
    try {
      window.localStorage.setItem('nm-theme', next)
    } catch {
      // A blocked storage API must not break the toggle for the session.
    }
  }

  return (
    <button className="theme-toggle" type="button" data-hydrated="true" onClick={toggle} aria-pressed={theme === 'dark'}>
      <span className="sr-only">Switch to </span>
      {theme === 'dark' ? 'LIGHT' : 'DARK'}
      <span className="sr-only"> theme</span>
    </button>
  )
}
